import { loadingCycle } from './page';
import api from '../../utils/service';

export const fetchInvoices = () =>
  loadingCycle(
    api.get('/invoices').then(
      ({
        data: {
          body: { invoices },
        },
      }) => invoices,
    ),
  );



// WEBPACK FOOTER //
// ./src/redux/modules/invoice.js